import {
  CONCESSION_STATUS_NOT_STARTED,
  CONCESSION_STATUS_ACTIVE,
  CONCESSION_STATUS_ENDING_SOON,
  CONCESSION_STATUS_EXPIRED,
} from 'common/concessionConstants';

import {
  getConcessionEndMoment,
  getConcessionStatus,
} from 'common/concessionHelpers';

import {
  SR_API_ACTION_CONCESSIONS_END,
} from 'api/actionTypes';

import ConcessionActions from 'client/actions/Concession';

import useDispatch from 'client/hooks/useDispatch';
import postWithState from 'client/actions/postWithState';

const CONCESSION_STATUS_TO_UI_SETTINGS_MAPPING = {
  [CONCESSION_STATUS_NOT_STARTED]: {
    color: 'grey',
    text: 'Rent Concession Not Started',
    endConcessionCtaActive: false,
  },
  [CONCESSION_STATUS_ACTIVE]: {
    color: 'green',
    text: 'Active Rent Concession',
    endConcessionCtaActive: true,
  },
  [CONCESSION_STATUS_ENDING_SOON]: {
    color: 'orange300',
    text: 'Rent Concession Ends Soon',
    endConcessionCtaActive: true,
  },
  [CONCESSION_STATUS_EXPIRED]: {
    color: 'red',
    text: 'Inactive Rent Concession',
    endConcessionCtaActive: false,
  },
};

const useConcessionsProController = ({ concession }) => {
  const concessionStatus = getConcessionStatus({ concession });
  const dispatch = useDispatch();

  const onEndConcessionSubmit = () => {
    return dispatch(postWithState, {
      action: SR_API_ACTION_CONCESSIONS_END,
      payload: {
        concessionId: concession.id,
      },
    })
      .then(() => {
        return dispatch(ConcessionActions.getByListingId, {
          listingId: concession.listingId,
          forceReload: true,
        });
      });
  };

  return {
    ...CONCESSION_STATUS_TO_UI_SETTINGS_MAPPING[concessionStatus],
    expirationText: `Ends ${getConcessionEndMoment({ concession }).format('MMMM Do')}`,
    onEndConcessionSubmit,
  };
};

export default useConcessionsProController;
